import React from 'react';
import PropTypes from 'prop-types';

import colors from 'theme/_colors.scss';

const IconLocation = ({ width = '16px', height = '16px', viewBox = '0 0 16 16', color = colors.mineShaft }) =>
    <svg width={width} height={height} viewBox={viewBox} fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M12.0029 6C14.1922 5.99333 15.9773 7.69335 16 9.80664C16 13.14 12.0029 16 12.0029 16C11.9646 15.9726 7.98673 13.1239 8 9.80664C8.02337 7.69015 9.81182 5.98889 12.0029 6ZM5.66699 12.2773H6.44434V13.4443H5.66699V15H1V10.333H2.55566V9.55566H3.72168V10.333H5.66699V12.2773ZM2.16699 11.5V13.833H4.5V11.5H2.16699ZM8.22266 12.2773V13.4443H7.22266V12.2773H8.22266ZM12.0029 8.66699C11.2411 8.66721 10.6231 9.26349 10.623 10C10.623 10.7365 11.2411 11.3328 12.0029 11.333C12.3666 11.334 12.717 11.194 12.9795 10.9424C13.2387 10.6931 13.3838 10.3532 13.3838 10C13.3838 9.26335 12.7656 8.66699 12.0029 8.66699ZM3.72168 7.22266V8.77734H2.55566V7.22266H3.72168ZM5.66699 1V2.7334H6.44434V3.90039H5.66699V5.66699H3.72168V6.44434H2.55566V5.66699H1V1H5.66699ZM15 5.66699H10.333V3.90039H9.55566V2.7334H10.333V1H15V5.66699ZM2.16699 4.5H4.5V2.16699H2.16699V4.5ZM11.5 2.16699V4.5H13.833V2.16699H11.5ZM8.77734 3.90039H7.22266V2.7334H8.77734V3.90039Z' fill={color} />
    </svg>;

IconLocation.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    viewBox: PropTypes.string,
    color: PropTypes.string
};

export default IconLocation;
